import { FC } from 'react';
import { useIndividualAccountData } from './individual-account.hook';

/**
 * IndividualAccount component
 * @description Content for the Reports IndividualAccount flow.
 * @link https://www.figma.com/file/16ideRW6XB1s57uA93ppSl/Manager--%7C-File-for-development?type=design&node-id=2118-411844&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const IndividualAccount: FC = () => {
  const { stages, currentStage } = useIndividualAccountData();

  return stages && currentStage ? stages[currentStage] : null;
};

export { IndividualAccount };
